import {createSlice} from '@reduxjs/toolkit';

const initialState = {data: ''};

const wellIdForStatusSlice = createSlice({
    name: 'wellIdForStatus',
    initialState,
    reducers: {
        setSeletedWellForStatus: (state, action) => {
            state.data = action.payload;
        },
    },
});

export const {setSeletedWellForStatus} = wellIdForStatusSlice.actions;

export default wellIdForStatusSlice.reducer;
